/**
 * The upgrade terminal: a pedestal with a screen canted back toward whoever is standing at it.
 *
 * Across the room from the stash, so spending what a raid earned is a walk taken on purpose rather
 * than something done while unloading.
 *
 * Inert. Spending points is #211's, and the screen says nothing until then.
 */

import { stationPart } from '@/modes/hub/sim/stations/stationParts';
import type { HubStation } from '@/modes/hub/sim/stations/hubStationContract';
import type { StationFrame } from '@/modes/hub/sim/stations/stationParts';
import { vec3 } from '@/sim/vec3';

const FRAME: StationFrame = {
  kindId: 'upgradeTerminal',
  position: vec3(11, 0, -4),
  yawDegrees: 90,
};

export const UPGRADE_TERMINAL_STATION: HubStation = {
  ...FRAME,
  colliders: [
    stationPart(FRAME, 'pedestal', vec3(0, 0.45, -0.3), vec3(0.7, 0.45, 0.35), 'weatheredConcrete'),
    stationPart(FRAME, 'housing', vec3(0, 1.15, -0.1), vec3(0.7, 0.3, 0.2), 'armourSteel'),
    stationPart(FRAME, 'screen', vec3(0, 1.55, 0.05), vec3(0.6, 0.4, 0.06), 'armourSteel'),
  ],
};
